module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoVolibol-62226974.png";